import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import GochiTableHeadGroup from '../../components/molecules/GochiHistoryTableHeadGroup';
import GochiTableBodyGroup from '../../components/molecules/GochiHistoryTableBodyGroup';
// import TablePagination from '../../components/molecules/TablePagination';
// import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';
import ContentDialog from '../../components/molecules/ContentDialog';
import DeleteDialog from '../../components/molecules/DeleteDialog';
import { sendLogin } from '../../auth/Auth';
import { deleteGochi } from '../../actions/Gochis';
import ProgressDialog from '../../components/molecules/ProgressDialog';

const styles = {
  scrollTable: {
    maxHeight: '60vh',
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  stickyActionsColumn: {
    border: '1px solid #CCCCCC',
    '& table': {
      border: '1px solid #CCCCCC',
      borderLeft: 'none',
      borderTop: 'none',
      backgroundColor: '#ffffff'
    },
    '& table:first-child': {
      '& tr': {
        '& td:first-child, th:first-child': {
          backgroundColor: '#f5f5f5',
          position: 'sticky',
          left: 0,
          zIndex: 9,
          width: 130,
          minWidth: 130
        },
        '& td:nth-child(2), th:nth-child(2)': {
          backgroundColor: '#f5f5f5',
          position: 'sticky',
          left: 130,
          zIndex: 9,
          width: 100,
          minWidth: 100
        },
        '& td:nth-child(3), th:nth-child(3)': {
          backgroundColor: '#f5f5f5',
          position: 'sticky',
          left: 230,
          zIndex: 9,
          width: 200,
          minWidth: 200
        },
        '& td:nth-child(4), th:nth-child(4)': {
          backgroundColor: '#f5f5f5',
          position: 'sticky',
          left: 430,
          zIndex: 9,
          width: 100,
          minWidth: 200
        },
        '& th:first-child, th:nth-child(2), th:nth-child(3), th:nth-child(4)': {
          zIndex: '11 !important'
        }
      }
    },
    '& table th': {
      borderBottom: '2px solid #CCCCCC',
      zIndex: '10 !important',
      borderTop: '1px solid #CCCCCC',
      color: '#000000',
      fontWeight: 'bold',
      backgroundColor: '#ffffff'
    }
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      gochis: state.gochis,
      totalCount: state.gochis.totalCount,
      count: state.gochis.count,
      offset: state.gochis.offset,
      couponCountTotal: state.gochis.couponCountTotal,
      externalAmountTotal: state.gochis.externalAmountTotal,
      internalAmountTotal: state.gochis.internalAmountTotal,
      couponUsedCountTotal: state.gochis.couponUsedCountTotal,
      usedExternalAmountTotal: state.gochis.usedExternalAmountTotal,
      usedInternalAmountTotal: state.gochis.usedInternalAmountTotal,
      discountAmountTotal: state.gochis.discountAmountTotal,
      transferAmountTotal: state.gochis.transferAmountTotal,
      amountTransferToShopWhenUseTotal:
        state.gochis.amountTransferToShopWhenUseTotal,
      amountTransferToShopWhenBuyTotal:
        state.gochis.amountTransferToShopWhenBuyTotal
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          deleteGochi
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('loading', 'updateLoading', false),
  withState('openFullMessage', 'updateOpenFullMessage', false),
  withState('fullMessage', 'setFullMessage', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDeleteProgress', 'updateOpenDeleteProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('deleteMessage', 'setDeleteMessage', ''),
  withState('isDeleteSuccess', 'updateIsDeleteSuccess', false),
  // withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    page,
    actions,
    selectedPage,
    handleDeleteGochi,
    checkSession,
    gochis,
    couponCountTotal,
    externalAmountTotal,
    internalAmountTotal,
    couponUsedCountTotal,
    usedExternalAmountTotal,
    usedInternalAmountTotal,
    discountAmountTotal,
    transferAmountTotal,
    openFullMessage,
    updateOpenFullMessage,
    fullMessage,
    setFullMessage,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    order,
    orderBy,
    handleRequestSort,
    updateOpenDelete,
    openDelete,
    loading,
    updateLoading,
    updateOpenDeleteProgress,
    openDeleteProgress,
    roles,
    setResultMessage,
    updateIsDeleteSuccess,
    isDeleteSuccess,
    resultMessage,
    deleteMessage,
    setDeleteMessage,
    searchEs,
    isShop,
    amountTransferToShopWhenUseTotal,
    amountTransferToShopWhenBuyTotal,
    isFukuoka,
    isNaha,
    educateSystem,
    openUpdateAmountModal,
    openUpdateAmountHistory
  }) => {
    const totals = {
      couponCountTotal,
      externalAmountTotal,
      internalAmountTotal,
      couponUsedCountTotal,
      usedExternalAmountTotal,
      usedInternalAmountTotal,
      discountAmountTotal,
      transferAmountTotal,
      amountTransferToShopWhenUseTotal,
      amountTransferToShopWhenBuyTotal
    };

    const moreMessageAction = msg => {
      setFullMessage(msg);
      updateOpenFullMessage(true);
    };

    const deleteOpenAction = id => {
      let readyUse = false;
      if (searchEs) {
        gochis.gochisAll
          .filter(item => item.gochiBillId === id)
          .forEach(gochi => {
            if (gochi.coupons) {
              gochi.coupons.forEach(coupon => {
                if (coupon.useDate != null) {
                  readyUse = true;
                }
              });
            }
          });
      } else {
        gochis.gochis
          .filter(item => item.gochiBillId === id)
          .forEach(gochi => {
            if (gochi.coupons) {
              gochi.coupons.forEach(coupon => {
                if (coupon.useDate != null) {
                  readyUse = true;
                }
              });
            }
          });
      }
      if (readyUse) {
        setDeleteMessage(
          '利用されたクーポンが含まれます。ごちを削除してもよろしいですか？'
        );
      }

      updateOpenDelete(true);
      setTargetRowId(id);
    };

    const cancelAction = () => updateOpenDelete(false);

    const deleteAction = async () => {
      updateLoading(true);
      updateOpenDeleteProgress(true);
      const deletedGochi = await actions
        .deleteGochi(targetRowId)
        .then(data => checkSession(data));
      if (deletedGochi.type === 'DELETE_GOCHI_SUCCESS') {
        updateIsDeleteSuccess(true);
        handleDeleteGochi(null, selectedPage, rowsPerPage);
        setResultMessage('削除が完了しました。');
        updateLoading(false);
      } else {
        updateIsDeleteSuccess(false);
        setResultMessage('削除に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isDeleteSuccess) {
        updateOpenDelete(false);
        updateOpenDeleteProgress(false);
      } else {
        updateOpenDeleteProgress(false);
      }
    };

    let totalGochi = 0;
    if (gochis.gochis && gochis.gochis.length) {
      totalGochi = gochis.gochis.length;
    } else if (gochis.gochisAll && gochis.gochisAll.length) {
      totalGochi = gochis.gochisAll.length;
    }

    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalGochi - page * rowsPerPage);

    return (
      <div>
        <div
          className={`${classes.scrollTable} ${classes.stickyActionsColumn}`}
          id="scrollTableId"
        >
          <Table stickyHeader>
            <GochiTableHeadGroup
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              totals={totals}
              roles={roles}
              isFukuoka={isFukuoka}
              educateSystem={educateSystem}
            />
            <GochiTableBodyGroup
              gochis={gochis.list}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              messageViewAction={moreMessageAction}
              order={order}
              orderBy={orderBy}
              setTargetRowId={setTargetRowId}
              deleteOpenAction={deleteOpenAction}
              roles={roles}
              searchEs={searchEs}
              isShop={isShop}
              isFukuoka={isFukuoka}
              isNaha={isNaha}
              openUpdateAmountModal={openUpdateAmountModal}
              openUpdateAmountHistory={openUpdateAmountHistory}
            />
          </Table>
        </div>
        {/* )} */}
        <ContentDialog
          openContent={openFullMessage}
          updateOpenContent={updateOpenFullMessage}
          content={fullMessage}
        />
        <DeleteDialog
          openDelete={openDelete}
          updateOpenDelete={updateOpenDelete}
          cancelAction={cancelAction}
          deleteAction={deleteAction}
          targetRowId={targetRowId}
          target="ごち"
          deleteMessage={deleteMessage}
        />
        <ProgressDialog
          openProgress={openDeleteProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
